import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';
@Entity('product_count')
export class ProductCountEntity {
 
    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

      @Column("varchar", {
        nullable: true,
        name: "product_id",
        length: 50
    })
    productId: number;

    @Column('varchar', {
        nullable: false,
        name: 'count',
        length: 100,
    })
    count: string;



}



